import { Service } from "models/Service";

export class WorldCupTrivia extends Service {
  constructor() {
    super({
      adsPath: "mundialfutbol-2026/triviamundialista",
      meta: {
        description: `Trivia Mundial - Clarin.com`,
        keywords: '',
        title: `El mundialista - Clarin.com`,
        url: `el-mundialista`, 
        extra: [],
      },
      section: "el-mundialista",
      sectionName: "El mundialista",
      template: "WorldCupTrivia",
      title: `El mundialista`,
      widthFull: true,
      slug: "",
      titleHeader:"",
      enableFooter: false,
      showLiveblog: false,
      width100: true,
      classService: "trivia",
      autorefresh : false,
      showBannerH1: false,
      bannerHorizontalOff: ["horizontal3"],
      showNewsToday: false,
      subheaderEnable: false
    });    
  }

}